import { Button, Spinner } from "@heroui/react";
import { XIcon } from "lucide-react";
import { shortHex } from "../../utils";

export function ShieldingWaitingToast({
  txHash,
  onDismiss,
}: {
  txHash?: string;
  onDismiss: () => void;
}) {
  return (
    <div className="flex gap-4 items-center turnstile-toast-border shadow-xl p-4 rounded-xl text-white fixed bottom-24 right-8 z-50">
      <Spinner color="default" />
      <div>
        <div className="font-semibold">Bridging your tokens...</div>
        {txHash && <div>Txn: {shortHex(txHash)}</div>}
      </div>
      <Button variant="light" isIconOnly onPress={onDismiss} className="text-white">
        <XIcon />
      </Button>
    </div>
  );
}
